import React from 'react';

import { useSciDomain, LoaderRenderer } from 'components';
import { EventOptionPaymentStepName, OrderStatus } from 'enums';
import { useTrackPaymentStepDuration } from 'hooks';

type Props = {
  status: OrderStatus;
};

export const PaymentLoading: React.FC<Props> = ({ status }) => {
  useTrackPaymentStepDuration(
    status === OrderStatus.Requisites
      ? EventOptionPaymentStepName.Requisites
      : EventOptionPaymentStepName.TraderConfirm,
  );

  const { data: { loader } = {} } = useSciDomain();

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-w-full tw-max-w-2xl tw-mx-auto tw-p-16 tw-rounded-2xl tw-bg-payment-layout-out md:tw-py-40">
      <LoaderRenderer
        loaderUrl={loader}
        imageClassName="tw-w-48 tw-mb-8 tw-animate-pulse"
        showCountdown={status === OrderStatus.Requisites}
      />
    </div>
  );
};
